
import { Popup, PasswordInput } from "vant";

import Icon from "../components/icon/index.vue";
import PopupHeader from "../components/popup/header.vue";
import { PropType, Ref, ref } from "vue";

export default {
  name: "OTPPopup",
  components: {
    Icon,
    Popup,
    PopupHeader,
    PasswordInput,
  },
  emits: ["cancel", "apply"],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    position: {
      type: String as PropType<"top" | "bottom">,
      default: "bottom",
    },
  },
  setup() {
    const otp: Ref<string> = ref("1234");

    return {
      otp,
    };
  },
};
